import React from "react";
import { getCommonPinningStyles } from "./helpers";
import renderCell from "./renderCell";
import clsx from "clsx";
import {
  Z_INDEX,
  PINNED_ZINDEX,
  LAST_BOTTOM_ROW_INDEX,
  SUBMENU_VISIBLE_ZINDEX,
  SUBMENU_VISIBLE_OFFSET,
} from "./pinnedRow.constants";
import { useTheme } from "@stores/ThemeContext";
import { useTranslation } from "react-i18next";

const PinnedRow = ({
  row,
  table,
  index,
  id,
  headerHeight,
  pinnedRowHeight,
  highlightedColor,
  submenuVisible,
  popupOpen,
  setPopupOpen,
  appliedFilters,
  saveAndApplyFilter,
}) => {
  const rowHeight = pinnedRowHeight;
  const additionalSpace = headerHeight;
  const { isDarkMode, toggleTheme } = useTheme();
  const { t: translate } = useTranslation();

  return (
    <tr
      id={`pinned-row-${row.id}`}
      style={{
        backgroundColor: highlightedColor,
        width: "100%",
        zIndex:
          submenuVisible === row.id
            ? SUBMENU_VISIBLE_ZINDEX + row.id
            : SUBMENU_VISIBLE_OFFSET,
        position: "sticky",
        boxShadow: "0px 0px 1px #e1e1e1",
        top:
          row.getIsPinned() === "top"
            ? `${row.getPinnedIndex() * rowHeight + additionalSpace}px`
            : undefined,
        bottom:
          row.getIsPinned() === "bottom"
            ? `${
                (table.getBottomRows().length -
                  LAST_BOTTOM_ROW_INDEX -
                  row.getPinnedIndex()) *
                rowHeight
              }px`
            : undefined,
      }}
    >
      {row.getVisibleCells().map((cell) => {
        const { column } = cell;
        return (
          <td
            key={cell.id}
            className={clsx(
              `px-3.5 py-2 border border-l-transparent border-r-transparent shadow-inner-remove w-fit group dark:!bg-gray-600`,
              column.getIsPinned() &&
                "dark:after:bg-gray-600 after:content[''] after:absolute after:left-[-1px] after:top-0 after:w-[calc(100%+2px)] after:h-full after:bg-white after:z-[-1] after:opacity-70"
            )}
            style={{
              ...getCommonPinningStyles(
                column,
                index,
                highlightedColor,
                null,
                Z_INDEX,
                PINNED_ZINDEX,
                isDarkMode
              ),
              width: column.getSize(),
            }}
          >
            <div>
              {renderCell(
                row,
                cell,
                popupOpen,
                setPopupOpen,
                appliedFilters,
                saveAndApplyFilter,
                translate,
                false,
                null,
                isDarkMode
              )}
            </div>
          </td>
        );
      })}
    </tr>
  );
};

export default PinnedRow;
